import { z } from "zod";

/// DisplayType variants for a NOTICE (type 17) field.
export enum NoticeDisplayTypeEnum {
    /// Info notice (blue box) - uses ParameterValue (falls back to ParameterText if empty).
    INFO = 1,
    /// Warning notice (orange/yellow box) - uses ParameterValue (falls back to ParameterText if empty).
    /// Not used in the new request yet - prepared for future use.
    WARNING = 2,
}

export const NoticeDisplayTypeEnumSchema = z.nativeEnum(NoticeDisplayTypeEnum);
